import { TableColumn } from 'react-data-table-component';
import { Badge } from 'reactstrap';

interface IProps {
  name: string;
  isActive: boolean;
}

export const makeSectorsListColumns = (): TableColumn<IProps>[] => {
  return [
    {
      name: 'Nome',
      sortable: true,
      sortField: 'NAME',
      wrap: true,
      selector: (row) => row.name,
    },
    {
      name: 'Status',
      sortable: true,
      sortField: 'STATUS',
      width: '120px',
      selector: (row) => (row.isActive ? 'Ativo' : 'Inativo'),
      cell: (row) => (
        <Badge color={row.isActive ? 'success' : 'secondary'} pill>
          {row.isActive ? 'Ativo' : 'Inativo'}
        </Badge>
      ),
    },
  ];
};
